import { render } from "./RefCampaignLeads.vue?vue&type=template&id=67ffcc0a&scoped=true"
import script from "./RefCampaignLeads.vue?vue&type=script&lang=js"
export * from "./RefCampaignLeads.vue?vue&type=script&lang=js"

import "./RefCampaignLeads.vue?vue&type=style&index=0&id=67ffcc0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ffcc0a"]])

export default __exports__